module.exports = __webpack_public_path__ + "img/portrait-030.93a0a802.jpg";